import React from 'react';
import { InvestorBankingDetailsError, useInvestorBankingDetailsContext } from './InvestorBankingDetailsContext';
import { DesktopOnly } from '../../../styling/layout/DesktopOnly';
import { DesktopInvestorBankingDetails } from './DesktopInvestorBankingDetails';
import { MobileOnly } from '../../../styling/layout/MobileOnly';
import { MobileInvestorBankingDetails } from './MobileInvestorBankingDetails';
import { Alert } from '../../../infrastructure/interface/components/Alert';
import { bankingDetailsActionStatusesByCode } from './BankingDetailsActionStatus';
import { useInternationalisation } from '../../../internationalisation/hooks/useInternationalisation';
import { Panel } from '../../../infrastructure/interface/components/Panel';

export const InvestorBankingDetails = () => {
  const { translate } = useInternationalisation();

  const {
    bankingDetailsRequestError,
    permissionsRequestError,
    deleteSuccessStatusCode,
    permissionsResponse,
  } = useInvestorBankingDetailsContext();

  const canEdit =permissionsResponse?.canEditBankingDetails ?? false;
  
  if (bankingDetailsRequestError || permissionsRequestError) {
    return <InvestorBankingDetailsError />;
  }

  return (
    <>
      {deleteSuccessStatusCode != null && (
        <Alert
          alertType="positive"
          header={translate('pages.bankingDetails.delete.successMessage.header')}
          withMarginTop={true}
        >
          {deleteSuccessStatusCode === bankingDetailsActionStatusesByCode.Authorised
            ? translate('pages.bankingDetails.delete.successMessage.authorised')
            : translate('pages.bankingDetails.delete.successMessage.pending')}
        </Alert>
      )}
      <DesktopOnly>
        <Panel>
          <DesktopInvestorBankingDetails canEdit={canEdit}/>
        </Panel>
      </DesktopOnly>
      <MobileOnly>
        <MobileInvestorBankingDetails canEdit={canEdit}/>
      </MobileOnly>
    </>
  );
};
